/**
 * Panel-side timing. Budget numbers (the 10-minute gap, 3 a day, welcome
 * snoozes, the decline pause) live in `@bookora/shared` because the server
 * and the smart guide use them too.
 */
export const WELCOME_DELAY_MS = 800;
export const QUIET_MS = 1_200;
export const WELCOME_MAX_WAIT_MS = 10_000;
export const OFFER_MAX_WAIT_MS = 15_000;
export const OFFER_AUTO_COLLAPSE_MS = 20_000;
export const OFFER_SCROLL_COLLAPSE_PX = 200;
export const OFFER_MAX_IMPRESSIONS = 2;
export const OFFER_REOFFER_AFTER_MS = 20 * 3_600_000;
export const CHIP_RETIRE_AFTER_MS = 14 * 86_400_000;
export const ANCHOR_WAIT_MS = 1_500;
/** Once one step's anchor is on the page, how much longer the others get. */
export const ANCHOR_GRACE_MS = 400;
export const SCROLL_SETTLE_MAX_MS = 350;
export const OVERLAY_POLL_MS = 250;
export const OVERLAY_PAUSE_MAX_MS = 60_000;
/** A page tour armed before navigating there (its chip starts it on arrival). */
export const ARMED_TTL_MS = 10 * 60_000;
export const QUEUE_MAX = 50;
export const QUEUE_RETRY_MS = 5_000;
export const STEP_VIEWED_FLUSH_MS = 10_000;
export const INLINE_OFFER_MIN_OPENS = 2;
/**
 * A context tour (a patient's file, an inline form, an import review) waits
 * for the user to open its place: «دفعهٔ بعد که فرم را باز کنید» has to hold
 * for a working day, not ten minutes. Kept per tab (sessionStorage).
 */
export const CONTEXT_ARMED_TTL_MS = 8 * 3_600_000;

/* ── Struggle detection (critic C6) ─────────────────────────────────────── */
/** A help offer waits for a longer pause than a first-visit offer … */
export const HELP_QUIET_MS = 4_000;
/** … and gives up after this long without one. */
export const HELP_MAX_WAIT_MS = 30_000;
/** A trip that could not be offered yet (a dialog on top) is retried this long … */
export const HELP_PENDING_MAX_MS = 2 * 60_000;
/** … this often. */
export const HELP_RETRY_MS = 1_500;
/** The same ApiError code twice in a section within … */
export const STRUGGLE_API_ERROR_WINDOW_MS = 5 * 60_000;
export const STRUGGLE_API_ERROR_COUNT = 2;
/** Two validation bursts on the same form within … */
export const STRUGGLE_VALIDATION_WINDOW_MS = 3 * 60_000;
export const STRUGGLE_VALIDATION_COUNT = 2;
/** Validation errors appearing this close together are one burst. */
export const STRUGGLE_BURST_MS = 1_000;
/** Three presses (clicks or taps) on the same blocked button within … */
export const STRUGGLE_BLOCKED_WINDOW_MS = 20_000;
export const STRUGGLE_BLOCKED_COUNT = 3;
/** Two opens of an inline form closed without a save within … */
export const STRUGGLE_ABANDON_WINDOW_MS = 30 * 60_000;
export const STRUGGLE_ABANDON_COUNT = 2;
/** A section counts as «hot» (the Help menu says «کمک برای همین قسمت») this long after a signal. */
export const STRUGGLE_HOT_MS = 5 * 60_000;
/** At most one help offer per context a day, and none for 14 days after a «نه، ممنون». */
export const HELP_CONTEXT_GAP_MS = 20 * 3_600_000;
export const HELP_DECLINE_BACKOFF_MS = 14 * 86_400_000;
/** A keydown this recent, with the caret in a field, means «still typing». */
export const EDITING_RECENT_MS = 8_000;
